import { useContext } from 'react'
import { ModalContext } from 'components/Modals/ModalContext'
import { useSelector } from 'react-redux'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'
import { GetWorkoutTemplateNameFromKey } from 'functions/textUtils'
import { ff, flags } from 'functions/roleBasedAccessUtils'

import SetsOverrideInput from 'components/Modals/Components/WorkoutOverrideModal/SetsOverrideInput'
import SlotOverrideListItem from 'components/Modals/Components/WorkoutOverrideModal/SlotOverrideListItem'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function WorkoutTemplateModalRouteView() {

    const { modalData } = useContext(ModalContext)

    const { programTableColumn, StartWorkout } = useContext(WorkoutOverrideModalContext)

    const userType = useSelector((state) => state.user.type)
    const enableCoachRunningWorkouts = useSelector((state) => state.user.enableCoachRunningWorkouts)

    const canRunWorkouts = ff(flags.canRunWorkouts, { userType: userType, enableCoachRunningWorkouts: enableCoachRunningWorkouts })

    return (
        <div className='space-y-4'>
            <div className='-mt-5 space-y-1'>
                <div className="text-xl text-left text-base font-semibold leading-6 text-gray-900">
                    Edit {GetWorkoutTemplateNameFromKey(modalData.workoutTemplateKey)}
                </div>

                <p className='text-sm text-left'>
                    Preview workout details below. Strength workouts are editable.
                </p>
            </div>

            <div className='h-[75vh] space-y-4 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                {programTableColumn.exerciseData[modalData.workoutTemplateKey].map((phase, phaseIndex) => (
                    <div 
                        key={phaseIndex}
                        className='border border-gray-400 rounded-lg divide-y divide-gray-400 overflow-hidden'
                    >
                        <div className='flex items-center gap-x-2 p-2 bg-gray-100'>
                            <div className='text-left text-lg font-bold pl-1'>{phase.name}</div>

                            <div className='flex-1'/>
                            
                            <SetsOverrideInput phaseIndex={phaseIndex} />
                        </div>

                        {phase.slots.map((_, slotIndex) => (
                            <SlotOverrideListItem 
                                key={slotIndex}
                                programTableColumnTaperData={programTableColumn.volumeData.taperData}
                                phaseVolumeData={programTableColumn.volumeData.setsAndRepsData[modalData.workoutTemplateKey][phaseIndex]}
                                phaseIndex={phaseIndex}
                                slotIndex={slotIndex}
                            />   
                        ))}
                    </div>
                ))}
            </div>

            {canRunWorkouts && modalData.showStartWorkoutButton &&
                <BrandColorButton
                    text='Start Workout'
                    action={StartWorkout}
                />
            }
        </div>
    )
}